import { render, staticRenderFns } from "./NotificationsCounter.vue?vue&type=template&id=176ae142&scoped=true&"
import script from "./NotificationsCounter.vue?vue&type=script&lang=js&"
export * from "./NotificationsCounter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsCounter.vue?vue&type=style&index=0&id=176ae142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ae142",
  null
  
)

export default component.exports